import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
// import FormComponent from '../FormComponent';
import TextField from '@mui/material/TextField';
import validateForm from '../../utils/validateForm';

const FormContainer = styled.div`
  margin-top: 1rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto auto auto;
  justify-items: stretch;
  align-items: start;
  justify-content: stretch;
  align-content: start;
  grid-row-gap: 0;
  grid-column-gap: 1rem;
  grid-template-areas:
    'street number'
    'floor zipcode'
    'departament phone'
    'email email';
`;

const NumberContainer = styled.div`
  grid-area: number;
`;
const StreetContainer = styled.div`
  grid-area: street;
`;

const FloorContainer = styled.div`
  grid-area: floor;
`;

const DepartamentContainer = styled.div`
  grid-area: departament;
`;

const ZipcodeContainer = styled.div`
  grid-area: zipcode;
`;

const PhoneContainer = styled.div`
  grid-area: phone;
`;
const EmailContainer = styled.div`
  grid-area: email;
`;

const Label = styled.h5`
  font-size: 1.05rem;
  text-align: left;
  color: gray;
  margin-top: 0.5rem;
`;

function UserDataForm({ formData, setFormData }) {
  const [errors, setErrors] = useState(validateForm(formData));
  const handleChange = (e) => {
    setErrors(
      validateForm({ ...formData, [e.target.id]: e.target.value }));
    setFormData(
      { ...formData, [e.target.id]: e.target.value });
  };

  useEffect(() => {
    setFormData({ ...formData, validate: errors.validate })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors.validate]);

  return (
    <FormContainer>
      <StreetContainer>
        <Label>Dirección*</Label>
        <TextField
          error={!!errors.street}
          helperText={errors.street}
          hiddenLabel
          variant="outlined"
          defaultValue={formData.street}
          fullWidth
          margin="dense"
          onChange={handleChange}
          id="person_address_street"
          style={{ backgroundColor: 'white' }}
        />
      </StreetContainer>
      <NumberContainer>
        <Label>Número*</Label>
        <TextField
          error={!!errors.number}
          helperText={errors.number}
          hiddenLabel
          variant="outlined"
          defaultValue={formData.number}
          fullWidth
          margin="dense"
          onChange={handleChange}
          id="person_address_number"
          style={{ backgroundColor: 'white' }}
        />
      </NumberContainer>
      <FloorContainer>
        <Label>Piso</Label>
        <TextField
          hiddenLabel
          variant="outlined"
          defaultValue={formData.floor}
          fullWidth
          margin="dense"
          onChange={handleChange}
          id="person_address_floor"
          style={{ backgroundColor: 'white' }}
        />
      </FloorContainer>
      <DepartamentContainer>
        <Label>Departamento</Label>
        <TextField
          hiddenLabel
          variant="outlined"
          defaultValue={formData.departament}
          fullWidth
          margin="dense"
          onChange={handleChange}
          id="person_address_departament"
          style={{ backgroundColor: 'white' }}
        />
      </DepartamentContainer>
      <ZipcodeContainer>
        <Label>Cod. Postal*</Label>
        <TextField
          error={!!errors.zipcode}
          helperText={errors.zipcode}
          hiddenLabel
          variant="outlined"
          defaultValue={formData.zipcode}
          fullWidth
          margin="dense"
          onChange={handleChange}
          id="person_address_zipcode"
          style={{ backgroundColor: 'white' }}
        />
      </ZipcodeContainer>
      <PhoneContainer>
        <Label>Teléfono*</Label>
        <TextField
          error={!!errors.phone}
          helperText={errors.phone}
          hiddenLabel
          variant="outlined"
          defaultValue={formData.phone}
          fullWidth
          margin="dense"
          onChange={handleChange}
          id="person_phone"
          style={{ backgroundColor: 'white' }}
        />
      </PhoneContainer>
      <EmailContainer>
        <Label>Email*</Label>
        <TextField
          error={!!errors.mail}
          helperText={errors.mail}
          hiddenLabel
          variant="outlined"
          defaultValue={formData.mail}
          fullWidth
          margin="dense"
          onChange={handleChange}
          id="person_mail"
          style={{ backgroundColor: 'white' }}
        />
      </EmailContainer>
    </FormContainer>
  );
}

export default UserDataForm;
